import React, { useState, useMemo, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  ListSubheader,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const containsText = (text, searchText) =>
  text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

export const MuiComboBoxWithSearch = (props) => {
  const { id, list, onChange, selectedReportId } = props;
  const [selectedOption, setSelectedOption] = useState(
    id === "facilityId" && list.length > 0 ? list[0] : {}
  );

  useEffect(() => {
    if (id !== "reportId") {
      setSelectedOption({});
      onChange(id, id, null);
    }
  }, [selectedReportId]);

  const [searchText, setSearchText] = useState("");
  const displayedOptions = useMemo(() => {
    if (!searchText) {
      return list;
    } else {
      return list?.filter((option) => containsText(option?.label, searchText));
    }
  }, [list, searchText]);

  useEffect(() => {
    if (id === "facilityId" && list.length > 0) {
      setSelectedOption(list[0]);
    } else if (list?.length <= 0) {
      setSelectedOption({});
    }
  }, [list]);

  const handleMenuItemClick = (option) => {
    setSelectedOption(option);
    setSearchText(option.label);
    onChange(id, id, option?.id);
  };

  return (
    <FormControl
      id={"formComboWithSearch_" + id}
      name={"formComboWithSearch_" + id}
      fullWidth
    >
      <Select
        MenuProps={{
          autoFocus: false,
          MenuListProps: {
            autoFocusItem: false,
          },
        }}
        labelId="search-select-label"
        id={id}
        value={searchText ? "" : selectedOption?.label || ""}
        size="small"
        label=""
        onChange={(e) => setSearchText(e.target.value)}
        onClose={() => setSearchText("")}
      >
        <ListSubheader>
          <TextField
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {displayedOptions.map((option) => (
          <MenuItem
            key={option.id}
            value={option.label}
            onClick={() => handleMenuItemClick(option)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
